import {observer} from 'mobx-react';
import {Panel, Button, ProgressIndicator} from 'shared/components';
import {FormattedMessage} from 'react-intl';
import {t} from 'shared/core';
import EndReviewModal from './EndReviewModal';
import useModal from 'shared/hooks/useModal';

const ReviewInProgressSummaryPanel = observer(({uiState}) => {
  const {cycle} = uiState;
  const {
    completedRevieweesPercentage,
    completedReviewees,
    reviewees,
    startedReviewees
  } = cycle;

  const progressBarItems = [
    {label: t('performance_reviews.view.Completed'), value: completedReviewees, color: '#08BAD3'},
    {label: t('performance_reviews.view.Started'), value: startedReviewees - completedReviewees, color: '#AEE1E8'},
    {label: t('performance_reviews.view.No Progress'), value: reviewees.length - startedReviewees, color: '#EBEFF1'}
  ];

  const endCycleModalOpen = useModal(uiState, 'EndCycleModal');

  return (
    <Panel>
      <Panel.Header title={t('performance_reviews.view.Review Cycle Overview')}>
        <Button trait='destructive' onClick={() => uiState.openEndCycleModal()}>
          <FormattedMessage id='performance_reviews.view.Close Review Cycle'/>
        </Button>
      </Panel.Header>
      <div className='col-6'>
        <div className='medium'>
          <FormattedMessage id='performance_reviews.view.Completion'/>
        </div>
        <div className='waterloo'>
          <FormattedMessage
            id='performance_reviews.view.RATIO_AND_PERCENTAGE_COMPLETION'
            values={
              {
                completedReviewees: completedReviewees,
                totalReviewees: reviewees.length,
                completedRevieweesPercentage: completedRevieweesPercentage
              }
            }
          />
        </div>
      </div>
      {reviewees.length > 0 && <div className='pt3'>
        <ProgressIndicator items={progressBarItems} displayLegend/>
      </div>}
      <EndReviewModal modalOpen={endCycleModalOpen} uiState={uiState}/>
    </Panel>
  );
});

export default ReviewInProgressSummaryPanel;
